/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import RedirectToLastVisitedProjectPageInternal from '@jira/spa-apps__common/src/defaultExport.tsx';

/** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains.
 *
 * NavigationUpdater is here as RedirectToLastVisitedProjectPage does not contain an AsyncSpaPage component
 * and we need to trigger the loading skeleton in nav.
 * */
export const RedirectToLastVisitedProjectPage = (): React.JSX.Element => (
	// @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type 'RouteContext': location, query, route, match, action
	<RedirectToLastVisitedProjectPageInternal />
);
